import { useSelector } from 'react-redux';
import { hmenu, get_now_smenu } from "@/pcomponents/comp/layout/menu/data/menu_arr";
function MenualBtnArea(props: any) {
  let myProps = {
    ...props
  };
  let user = useSelector((state: any) => state.user);

  let comp_sort_detail = user.comp_sort_detail;
  if (location.hostname == "dalirant.planiedu.com") {
    comp_sort_detail = "dalirant";
  }

  let now_h_key = "";
  let now_smenu = get_now_smenu({
    "user_grade": user.user_grade,
    "comp_sort_detail": comp_sort_detail,
    user: user,
  });
  if (now_smenu) {
    now_h_key = now_smenu.hmenu;
  }

  const hmenu_menual_json: any = {
    h_student: { data_url: process.env.REACT_APP_API_URL + "/home/manual/manage/data/pdf/1._원생관리.pdf" },
    h_prescribe: { data_url: process.env.REACT_APP_API_URL + "/home/manual/manage/data/pdf/2._학습처방.pdf" },
    h_plan: { data_url: process.env.REACT_APP_API_URL + "/home/manual/manage/data/pdf/3._맞춤플랜.pdf" },
    h_desk: { data_url: process.env.REACT_APP_API_URL + "/home/manual/manage/data/pdf/4._시간표&좌석.pdf" },
    h_lecture: { data_url: process.env.REACT_APP_API_URL + "/home/manual/manage/data/pdf/5._수업관리.pdf" },
    h_supply: { data_url: process.env.REACT_APP_API_URL + "/home/manual/manage/data/pdf/6._수납관리.pdf" },
    h_sms: { data_url: process.env.REACT_APP_API_URL + "/home/manual/manage/data/pdf/7._문자&알림톡.pdf" },
    h_book_order: { data_url: process.env.REACT_APP_API_URL + "/home/manual/manage/data/pdf/8._교재주문.pdf" },
  };

  let menual_url = "";
  if (now_h_key && hmenu_menual_json[now_h_key]) {
    menual_url = hmenu_menual_json[now_h_key].data_url;
  }
  var win_w=(window.innerWidth || document.documentElement.clientWidth);
  if(win_w<700){
    menual_url="";
  }

  let menual_btn_style: any = {
    marginRight: "10px",
    padding: "4px 8px",
    fontSize: "13px",
    fontWeight: "500",
    color: "#3b82f6",
    backgroundColor: "transparent",
    border: "1px solid #dbeafe",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  };

  return (
    <div>
      {menual_url &&
        <button
          title='메뉴얼 보러가기'
          style={menual_btn_style}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#2563eb";
            e.currentTarget.style.borderColor = "#93c5fd";
            e.currentTarget.style.backgroundColor = "#eff6ff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#3b82f6";
            e.currentTarget.style.borderColor = "#dbeafe";
            e.currentTarget.style.backgroundColor = "transparent";
          }}
          onClick={() => {
            window.open(menual_url);
          }}>도움말</button>
      }
    </div>
  );
};
export default MenualBtnArea;